import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { BlockStateData } from './types';

const initialState: BlockStateData = {
	data: { data: { message: '', error: '' }, error: null },
	loading: false,
	error: '',
};

export const fetchBlock = createAsyncThunk(
	'api/fetchBlock',
	({ sessionId, fromDate, toDate }: { sessionId: string; fromDate: string; toDate: string }) =>
		api.fetchBlock(sessionId, fromDate, toDate)
);

const voluntaryBlockSlice = createSlice({
	name: 'voluntaryBlock',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchBlock.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchBlock.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchBlock.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message || 'Ошибка загрузки данных';
			});
	},
});

export default voluntaryBlockSlice.reducer;
